import React from "react";
import { objToQueryString, queryStringToJSON } from "../utils/common";

const Pagination = ({ onPageChange, pageSize, totalCount, prev = null, next = null }) => {
	const pages = pageSize || totalCount;
	const pageLength = Math.ceil(isNaN(totalCount / pages) ? 0 : totalCount / pages);
	const currentData = next ? queryStringToJSON(next) : prev ? queryStringToJSON(prev) : { offset: pageLength * pages };
	const currentOffset = Number(currentData.offset);
	const currentPage = next ? currentOffset / pages : currentOffset / pages + 2;

	const filterPages = (visiblePages, totalPages) => {
		return visiblePages.filter((page) => page <= totalPages);
	};

	const getVisiblePages = (page, total) => {
		if (total < 7) {
			return filterPages([1, 2, 3, 4, 5, 6], total);
		} else {
			if (page % 5 >= 0 && page > 4 && page + 2 < total) {
				return [1, page - 1, page, page + 1, total];
			} else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
				return [1, total - 3, total - 2, total - 1, total];
			} else {
				return [1, 2, 3, 4, 5, total];
			}
		}
	};

	return pageLength > 1 ? (
		<div className="pagination-wrap">
			<button type="button" disabled={!prev} className="btn pagination-prev" onClick={() => onPageChange("prev", prev)}>
				<i className="icon icon-angle-left" />
			</button>
			{getVisiblePages(currentPage, pageLength).map((page) => {
				if (isNaN(page)) {
					return null;
				}
				const offset = (page - 1) * pages;
				const url = `?${objToQueryString({
					...currentData,
					offset
				})}`;
				return (
					<button
						key={page}
						type="button"
						disabled={currentPage === page}
						className="btn pagination-number"
						onClick={() => onPageChange("page", url)}>
						{page}
					</button>
				);
			})}
			<button type="button" disabled={!next} className="btn pagination-next" onClick={() => onPageChange("next", next)}>
				<i className="icon icon-angle-right" />
			</button>
		</div>
	) : null;
};

export default Pagination;
